import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App, { preloadForPath } from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

const container = document.getElementById("root");

// Prerendered pages (scripts/prerender.mjs) ship with populated HTML inside
// #root — hydrate them in place instead of wiping and re-rendering. Bare
// shells (dev server without a snapshot) get a normal client render. When the
// current route is code-split, its chunk is preloaded first so hydration sees
// the fully resolved component tree (no Suspense fallback flash).
const boot = async () => {
  if (container.hasChildNodes()) {
    await preloadForPath(window.location.pathname).catch(() => {}); // hydrate regardless
    ReactDOM.hydrateRoot(container, app);
  } else {
    ReactDOM.createRoot(container).render(app);
  }
};
boot();
